import { ReaderBlockDiscussionCommentAdd } from '.';

import type { CommonBlockPropsReader } from 'components/reader/blocks';
import type { DiscussionSubmitObj } from './ReaderBlockDiscussion';

interface Props extends Pick<CommonBlockPropsReader<'discussion'>, 'fontSize'> {
  allowAnonymousComments: boolean;
  onCommentAdd: (params: DiscussionSubmitObj) => Promise<void>;
}

const ReaderBlockDiscussionActions = ({
  allowAnonymousComments,
  fontSize,
  onCommentAdd
}: Props) => (
  <div className="controls">
    <ReaderBlockDiscussionCommentAdd
      allowAnonymousComments={allowAnonymousComments}
      fontSize={fontSize}
      onSubmit={onCommentAdd}
    />

    <style jsx>{`
      .controls {
        align-items: flex-end;
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;
      }
    `}</style>
  </div>
);

export default ReaderBlockDiscussionActions;
